export default "__VITE_ASSET__3d2cd04f__"